"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./credentialDescriptionBlock.scss");
const credentialDescriptionBlockTranslations_json_1 = __importDefault(require("./credentialDescriptionBlockTranslations/credentialDescriptionBlockTranslations.json"));
const master_1 = require("../../../constants/master");
const subdomains_1 = require("../../../constants/subdomains");
function CredentialDescriptionBlock(props) {
    props.addTranslation(credentialDescriptionBlockTranslations_json_1.default);
    const config = (0, master_1.getMasterConfig)();
    function getDescriptionTranslationKey() {
        return config.subDomain === subdomains_1.himssSubdomain
            ? "certificateDescription"
            : "credentialDescription";
    }
    return (react_1.default.createElement("div", { className: "credential-description-block" },
        config.subDomain !== subdomains_1.nationalBlackLawyersSubdomain &&
            config.subDomain !== subdomains_1.nationalTrialLawyersSubdomain && (react_1.default.createElement("span", { className: "description-title" }, props.translate(getDescriptionTranslationKey()).toString())),
        props.details.detail.descriptionHtml ? (react_1.default.createElement("div", { className: "ql-editor", dangerouslySetInnerHTML: {
                __html: props.details.detail.descriptionHtml,
            } })) : (react_1.default.createElement("span", { className: "description-text" }, props.details.detail.description))));
}
exports.default = CredentialDescriptionBlock;
